export const PROJECT_ACCESS_GRANTED = 'project_access_granted';
export const PROJECT_ACCESS_REQUESTED = 'project_access_requested';
export const PROJECT_ACCESS_REJECTED = 'project_access_rejected';
